/** Hasta 4 decimales (precios, costos). */
export const DECIMAL_INPUT_PATTERN = /^\d*\.?\d{0,4}$/;

/** Hasta 3 decimales (cantidades en guías). */
export const QUANTITY_INPUT_PATTERN = /^\d*\.?\d{0,3}$/;

export const normalizeDecimalTyping = (raw) => String(raw ?? '').replace(',', '.').trim();

export const isDecimalInputString = (value, pattern = DECIMAL_INPUT_PATTERN) => {
  if (value === '' || value === null || value === undefined) return true;
  return pattern.test(normalizeDecimalTyping(value));
};

export const parseDecimalNumber = (value) => {
  if (value === '' || value === null || value === undefined) return 0;
  const n = parseFloat(normalizeDecimalTyping(value));
  return Number.isNaN(n) ? 0 : n;
};

export const formatDecimalFieldValue = (value, pattern = DECIMAL_INPUT_PATTERN) => {
  if (value === '' || value === null || value === undefined) return '';
  if (typeof value === 'string' && isDecimalInputString(value, pattern)) {
    return normalizeDecimalTyping(value);
  }
  const n = Number(value);
  return Number.isNaN(n) ? '' : String(n);
};

export const parseDecimalFieldInput = (raw, pattern = DECIMAL_INPUT_PATTERN) => {
  const normalized = normalizeDecimalTyping(raw);
  if (normalized === '') return { empty: true };
  if (!pattern.test(normalized)) return { invalid: true };
  const value = parseFloat(normalized);
  if (Number.isNaN(value)) return { invalid: true };
  return { value };
};

export const getDecimalInputPattern = (decimalPlaces = 3) =>
  decimalPlaces === 4 ? DECIMAL_INPUT_PATTERN : QUANTITY_INPUT_PATTERN;

export const roundDecimal = (value, decimalPlaces = 3) => {
  const n = parseFloat(value);
  if (!Number.isFinite(n)) return 0;
  const factor = 10 ** decimalPlaces;
  return Math.round(n * factor) / factor;
};
